<template>
  <div class="content-wrapper">
    <ContentHeader title="Заправки" />
    <div class="content-body">
      <card
        headerTitle="История заказов"
        :busy="isOrdersLoading"
        hideFooter
        @reload="reloadOrders"
      >
        <template slot="block">
          <b-table
            show-empty
            hover
            bordered
            responsive
            thead-class="bg-grey bg-lighten-2"
            :emptyText="
              isOrdersFailed
                ? 'Ошибка подключения. Попробуйте позже'
                : 'Записи отсутствуют'
            "
            emptyFilteredText="Записи не найдены"
            :sort-compare= "sortingChanged"

            :busy="isOrdersLoading"
            :items="getOrders"
            :fields="ordersFields"

            :total-rows="totalRows"
            :per-page="perPage"
            :current-page="currentPage"

            :_filter="filter||private_filter"
            :_filterIncludedFields="filterIncludedFields"
            @_filtered="$emit('filtered')"

            class="table-orderList"
          >
              <!--template v-slot:cell(card_id)="data">
                <div>
                  <span
                    class="btn-link"
                    @click="qrcodeValue = data.value.toString(); qrcodeShow = true"
                    style="cursor:pointer;"
                  >{{ data.value }}</span>
                </div>
              </template-->
              <template v-slot:cell(station_id)="data">
                <div>
                  <div
                    _class="btn-link"                    
                    _style="cursor:pointer;text-align:center;"
                  >{{ !data.value ? '?' : (getStationsById(data.value)?getStationsById(data.value).name:'') }}</div>
                </div>
              </template>
              <template v-slot:cell(card_id)="data">
                <div>{{ data.value ? getCardName(data.value) : '?' }} </div>
              </template>
              <template v-slot:cell(acc_id)="data">
                <div>{{ getAccName(data.item.card_id) }} </div>
              </template>
              <template v-slot:cell(status)="data">
                <div 
                  style="text-align:center;"
                >{{ data.value ? orderStatusList[data.value] : '?' }}
                </div>
              </template>
              <template v-slot:cell(product_id)="data">
                <div 
                  style="text-align:center;"
                >{{ data.value ? getFuelName(data.value) : '?' }}
                </div>
              </template>
              <template v-slot:cell(requested_quantity)="data">
                <div 
                >{{ data.value == 0 ? '-' : data.value }}
                </div>
              </template>
              <template v-slot:cell(requested_sum)="data">
                <div 
                >{{ data.value == 0 ? '-' : data.value }}
                </div>
              </template>
              <!--template v-slot:cell(status)="data">
                <span
                  class="tag tag-default"
                  :class="{
                    'bg-warning bg-red bg-darken-2':
                      data.value === 'Заблокирована',
                    'bg-green bg-darken-1': data.value === 'Активна',
                  }"
                  >{{ data.value }}</span
                >
              </template-->
              <!--template v-slot:cell(actions)="row">
                <div class="text-xs-center">
                  <span
                    class="btn-link"
                    :class="{ 'text-muted': row.item.block }"
                    title="Заблокировать"
                    style="cursor: pointer"
                    @click="
                      if (!row.item.block) {
                        showBlockModal = true;
                        discountCardNumber = row.item.card_id;
                      }
                    "
                    :disabled="row.item.block"
                  >
                    <i
                      class="icon-lock4 font-medium-5"
                      :class="{ ' icon-hover indigo': !row.item.block }"
                    ></i>
                  </span>
                </div>
              </template-->                
          </b-table>
          <div style="margin: 20px 0px;">
            <div>Всего записей: {{totalRows}}</div>
            <div>
              <div class="float-xl-left float-sm-none mt10">
                <select
                  v-model="perPage"
                  _id="issueinput5"
                  name="priority"
                  class="form-control"
                  data-toggle="tooltip"
                  data-trigger="hover"
                  data-placement="top"
                  data-title="На страницу"
                  data-original-title
                  title
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="float-xl-right">
                <nav aria-label="Page navigation">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    size="sm"
                    prev-text="« Пред."
                    next-text="След. »"
                    first-number
                    last-number
                  ></b-pagination>
                </nav>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>

  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import card from "@/components/card.vue";
import { mapGetters } from "vuex";
import { ORDERS_REQUEST } from "@/store/actions/orders";
import { STATIONS_REQUEST, FUELS_REQUEST } from "@/store/actions/stations";
import {
  CARDS_REQUEST,
  //CARDS_BALANCE_REQUEST,
  //CARDS_CLIENT_BALANCE_REQUEST,
  //CARDS_BLOCK_REQUEST,
  //CARDS_UNBLOCK_REQUEST,

  CARDS_ACCS_REQUEST,
  //CARDS_ACCS_SUCCESS,
  //CARDS_ACCS_ERROR,
} from "@/store/actions/cards";

export default {
  name: "Orders",
  components: {
    ContentHeader,
    card,
  },
  data() {
    return {
      //      fields: requestFields,
      modalId: "modal",
      showModal: false,
      card_id: null,
      station_id: null,
      product_id: null,
      trk_num: null,
      quantity: null,
      pay_method: null,

      modalStep: 0,

      orderStatusList: {
        0: "Заказ принят",
        1: "Заказ передан на станцию",
        2: "Заказ подтверждён оператором / начат отпуск",
        3: "Заказ завершен",
        400: "Заказ отменён сервером",
        401: "Нет связи с АЗС",
        402: "На ТРК уже есть заказ",
        500: "Заказ отменён АЗС",
        501: "ТРК занята",
        502: "Нет связи с ТРК",
        503: "ТРК неисправна",
        504: "Недостаточно топлива",
        505: "Введены неверные параметры",
        600: "Заказ отменён оператором",
      },

      ordersFields: [
        {
          key: "cdate",
          label: "Дата и время",
          formatter(value) {
            return new Date(value).toLocaleString();
          },
          filterByFormatted: true,
          thClass: "text-xs-center",
          sortable: true,
        },
        {
          key: "card_id",
          label: "Карта / Держатель",
          sortable: true,
        },
        { // virtual column for account
          key: "acc_id",
          label: "Карт-счёт",
          sortable: true,
        },        
        {
          key: "status",
          label: "Состояние",
          //formatter: (value, key, item) => {
          //  console.log(key);
          //  console.log(item);
          //  return value ? orderStatusList[value] : '?'; //item.block ? "Заблокирована" : "Активна";
          //},
          thClass: "text-xs-center",
          sortable: true,
        },
        {
          key: "station_id",
          label: "АЗС",
          thClass: "text-xs-center",
          sortable: true,
        },
        {
          key: "product_id",
          label: "Вид топлива",
          thClass: "text-xs-center",
          sortable: true,
        },
        {
          key: "pump_id",
          label: "ТРК №",
          thClass: "text-xs-center",
        },
        {
          key: "pay_method",
          thClass: "text-xs-center",
        },
        /*{
          key: "pay_type_id",
          thClass: "text-xs-center",
        },*/
        {
          key: "requested_quantity",
          label: "Заданное кол-во, л",
          thClass: "text-xs-center",
        },
        {
          key: "requested_sum",
          label: "Заданная сумма, ",
          thClass: "text-xs-center",
        },
        {
          key: "price",
          label: "Цена, ",
          thClass: "text-xs-center",
        },        
        {
          key: "quantity",
          label: "Кол-во, л",
          thClass: "text-xs-center",
          sortable: true,
        },
        {
          key: "sum",
          label: "Сумма, ",
          thClass: "text-xs-center",
          sortable: true,
        }
      ],

      itemsPerPage: 5,
      currentPage: 1,
      perPage: this.itemsPerPage ? this.itemsPerPage : 5,

      private_filter:null,
      filterIncludedFields: [],
      filter: null,

    };
  },
  computed: {
    ...mapGetters([
      "getCurrencyName",

      "getOrders",
      "isOrdersLoading",
      "isOrdersFailed",
      "ordersOnceLoaded",

       "getCards",
       "getCardById",
       "isCardsLoading",

      "getCardsAccs",
      "getCardsAccsById",
      "cardsAccsOnceLoaded",

      "getStations",
      "getStationsById",
      "stationsOnceLoaded",

      "getFuelById",
      "fuelsOnceLoaded",
    ]),
    totalRows() {
      return this.getOrders ? this.getOrders.length : 0;
    },
    isNextStepAllowed() {
      return (this.modalStep==undefined ||
          this.modalStep==0 && this.station_id!=undefined ||
          this.modalStep==1 && this.trk_num!=undefined)
    }
  },
  methods: {
    sortingChanged(a, b, key) {
      let res = 0;

      if (key == 'acc_id')        
      {
        let a1 = this.getAccName(a.card_id).toLowerCase();
        let b1 = this.getAccName(b.card_id).toLowerCase();

        if (a1 != b1)
          res = a1 > b1 ? 1 : -1;
        //console.log(`${key} ${sortDesc} - ${a1}, ${b1}, ${res}, `);
        return res;
      }
      return false;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    reloadOrders() {
      this.$store.dispatch(ORDERS_REQUEST);
    },
    getCardName(cardId) {
      let card = this.getCardById( cardId );

      if (!card)
        return '?';

      let cardName = card.holder_name ? card.id + ' / ' + card.holder_name : card.id;
      return cardName;
    },
    getAccName(cardId) {
      let card = this.getCardById( cardId );

      if (!card)
        return '?';

      let acc = this.getCardsAccsById( card.account_id);
      let accName = acc ? acc.name : '??';
      return accName;
    },
    getFuelName(productId) {
      let fuel = this.getFuelById(productId);
      return fuel ? fuel.name : '?';
    }
  },
  created() {
    if (!this.ordersOnceLoaded) this.$store.dispatch(ORDERS_REQUEST);
    if (!this.cardsOnceLoaded) this.$store.dispatch(CARDS_REQUEST);
    if (!this.stationsOnceLoaded) this.$store.dispatch(STATIONS_REQUEST);
    if (!this.cardsAccsOnceLoaded) this.$store.dispatch(CARDS_ACCS_REQUEST);
    if (!this.fuelsOnceLoaded) this.$store.dispatch(FUELS_REQUEST);
    if (this.getCurrencyName)
    {
      this.ordersFields.forEach(field => {
        if (field.key == "sum" || field.key == "requested_sum" || field.key == "price")
          field.label += this.getCurrencyName;
      })
    }
  },
};
</script>

<style>
.td-number {
  text-align: right;
}
.table-orderList td,
.table-orderList th {  
  padding: 0.25rem 0.5rem;
}
.table-orderList td {
  text-align: center;
}
.table-orderList td:nth-child(2),
.table-orderList td:nth-child(3) {  
  text-align: left;
}
.table-orderList td:nth-child(9),
.table-orderList td:nth-child(10),
.table-orderList td:nth-child(11),
.table-orderList td:nth-child(12),
.table-orderList td:nth-child(13),
.table-orderList td:nth-child(14) {
  text-align: right;
}

.station-btn {
  padding: 0.5em 1.5em;
  margin: 0.25em;
  border-radius: 0.25em;
  border: solid 0.1em lightgray;
  font-weight: bold;
}
.station-btn:hover {
  background: lightgray;
}
</style>